module.exports = __webpack_public_path__ + "static/media/plan-C2a-desktop-tc.20894baa.png";